export default {
    init() {
    },
    finalize() {

        // grab the checkboxs
        var serviceFilter = $('input[name="service-filter[]"]');

        function toggleService(thisObj) {
            var checked = thisObj.prop('checked');
            var value = thisObj.val();
            var dataServiceTermId = $('[data-service-term-id=' + value + ']');

            if (!checked) {
                dataServiceTermId.hide();
            } else {
                dataServiceTermId.show();
            }
        }

        // first go through each of the service filter inputs
        serviceFilter.each(function () {
            var self = $(this);

            // when a servie fulter is clicked
            self.on('click', function () {
                toggleService($(this));
            });
        })

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateServiceOverview.js